<template>
  <div class="row custom-extension">
    <div class="col text-center">
      <div class="row">
        <div class="col">
          <img src="https://opusadas.blob.core.windows.net/images/1/Opus_IVS_90h.png" alt="App" height="70%" />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <h5>OPUS IVS ADAS Map Pro Chrome Extension</h5>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <span>Follow this link to install the Chrome extension:</span>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <a href="https://chrome.google.com/webstore/detail/iilgboeocdcpnnieonbapkdmnlkkndfi" target="_blank"
            rel="noopener noreferrer">ADAS Map Pro Chrome Extension</a>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <span>Just click "Get" or "Add to Chrome" and then "Add Extension" to install.</span>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col">
      <h4>Profile</h4>
    </div>
  </div>
  <div class="row">
    <div class="col">{{ firstName }} {{ lastName }}</div>
  </div>
  <div class="row">
    <div class="col">{{ username }}</div>
  </div>
  <div class="row">
    <div class="col">{{ user }}</div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
export default {
  name: 'ProfileView',
  computed: {
    ...mapState(authStore, ['profile']),
    firstName() {
      return this.profile?.firstName || ''
    },
    lastName() {
      return this.profile?.lastName || ''
    },
    username() {
      return this.profile?.username || ''
    },
    user() {
      return this.profile?.user || ''
    },
  }
}
</script>
<style lang="scss" scoped>
.custom-extension {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
}
</style>
